import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Taken, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isInterneGebruiker && settings.takenSysteemToggle,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Taken,
    title: 'Taken',
    url: '/app/aanvraag/taken',
    iconclass: 'far fa-clipboard-check',
    target: '_top',
  }),
});
